export type LogarithmicOptions = {
  min: number
  max: number
}

export type SharesInputs = {
  shares: number
  totalPrice: number
  expectedReturnPlentyOnly: number
  expectedReturnPlentyWithBolt: number
}

export type SharesInputsWithOptionalShares = Omit<SharesInputs, 'shares'> & { shares: SharesInputs['shares'] | null }

export enum RoiTableRows {
  ROI = 'roi',
  ADVANTAGE_EL = 'advantage-el',
  ADVANTAGE_GAS = 'advantage-gas',
  TOTAL = 'total'
}

export enum RoiTableColumns {
  PLENTY = 'plenty',
  BOLT = 'bolt-and-plenty'
}

export type ReturnOnInvestmentTableProps = Pick<SharesInputs, 'expectedReturnPlentyOnly' | 'expectedReturnPlentyWithBolt' | 'shares'>
